<div class="header">
  <div class="title">
      @if (isUnified) {
      <h1 class="uc-display-xs uc-bold">{{'footer.faq' | translate}}</h1>
      } @else {
      <h3>{{'footer.faq' | translate}}</h3>
      }
  </div>
</div>

<div *ngIf="loaded && !platformFaqs?.length" class="container container-min-hight">
  <p class="text-center text-muted py-5 mb-0 uc-empty-state" translate="emptyState.noFaqs"></p>
</div>

<div *ngIf="platformFaqs?.length" class="container container-min-hight container-faq">
  <div class="row">
    <div class="accordion">
    <div class="col-md-10">
      <div class="card">
        <div class="card-body">
          <div ngbAccordion>
            <div ngbAccordionItem *ngFor="let faq of platformFaqs">
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton class="shadow-none">{{faq.questionTitle}}</button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>{{faq.answer}}</ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
